import { Component, OnInit, Renderer2 } from '@angular/core';

@Component({
  selector: 'app-main-loader',
  templateUrl: './main-loader.component.html',
  styleUrls: ['./main-loader.component.scss']
})
export class MainLoaderComponent implements OnInit {

  private blockLoader = false;

  constructor(private renderer: Renderer2) { }

  ngOnInit() {
    this.showLoader();
  }

  showLoader() {
    if (!this.blockLoader) {
      setTimeout(() => {
        // Add 'loaded' class to overlay and body
        this.renderer.addClass(document.querySelector('.overlay'), 'loaded');
        this.renderer.addClass(document.body, 'loaded');

        setTimeout(() => {
          // Set the 'display' property to 'none' after 2 seconds
          this.renderer.setStyle(document.querySelector('.overlay'), 'display', 'none');
        }, 3000); // Adjust the delay as needed
      }, 3000); // Set the delay to 4 seconds
    }
  }

}
